const initAccordion = () =>{
 const parent_header =  document.querySelector('.accordion-button:not(.collapsed)').closest('.accordion-header');
  parent_header.classList.add('is-show');
  const accordionCollapse = document.querySelectorAll('.ku-accordion .accordion-collapse');
  accordionCollapse.forEach(function(collapseEle) {
    collapseEle.addEventListener("hide.bs.collapse", function () {
      document.querySelectorAll('.accordion-header').forEach(function(ele){
        ele.classList.remove('is-show');
      });
    });
    collapseEle.addEventListener("shown.bs.collapse", function (event) {
      document.querySelectorAll('.accordion-header').forEach(function(ele){
        ele.classList.remove('is-show');
      });
     let parentAccordionItem = event.target.closest('.accordion-item');
     parentAccordionItem.querySelector('.accordion-header').classList.add('is-show');
    });
  });
}

export default initAccordion;
